export async function checkVersion() {
  try {
    const response = await fetch('/meta.json', { cache: 'no-store' });
    const meta = await response.json();
    const nuevaVersion = meta.version;

    const versionActual = localStorage.getItem('app_version');

    if (versionActual && versionActual !== nuevaVersion) {

      localStorage.setItem('app_version', nuevaVersion);
      window.location.reload(true);
    } else {
      localStorage.setItem('app_version', nuevaVersion);
    }
  } catch (error) {
    console.error('❌ Error verificando versión:', error);
  }
}
